import { IWeatherDailyWeather, LocationAPIResult, WeatherAPIResult } from '../types'
import * as constants from '../../bridge_interface/constants'

export const validateLocation = (location: LocationAPIResult): boolean => {
  return (
    !!location.location.latitude &&
    !!location.location.longitude &&
    // !!location.location.state.length && Washington DC does not return a state code.
    !!location.location.zipcode.length &&
    !!location.source.slugName.length &&
    !!location.source.currentLink.length &&
    !!location.source.hourlyLink.length &&
    !!location.source.tenDayLink.length &&
    !!location.source.sourceLink.length
  )
}

export const validateWeather = (weather: WeatherAPIResult) => {
  return (
    !!weather &&
    (weather.temperature === 0 || !!weather.temperature) &&
    (weather.temperatureMin === 0 || !!weather.temperatureMin) &&
    (weather.temperatureMax === 0 || !!weather.temperatureMax) &&
    (weather.temperatureFeelsLike === 0 || !!weather.temperatureFeelsLike) &&
    (weather.windSpeed === 0 || !!weather.windSpeed) &&
    (weather.relativeHumidity === 0 || !!weather.relativeHumidity)
  )
}

export const validateWeatherDaily = (weatherDaily: IWeatherDailyWeather[], app_theme: string) => {
  if (app_theme !== 'moment') return true
  return (
    !!weatherDaily &&
    !!weatherDaily.length &&
    (weatherDaily[0].temperature === 0 || !!weatherDaily[0].temperature) &&
    (weatherDaily[0].iconCode === 0 || !!weatherDaily[0].iconCode) &&
    !!weatherDaily[0].description
  )
}

export const getCurrentPosition = () => {
  const lat = localStorage.getItem(constants.LS_BRIDGE_LAT)
  const lng = localStorage.getItem(constants.LS_BRIDGE_LNG)

  // These are rounded to improve cache-ability.
  const latitude = Math.round(parseFloat(lat) * 100) / 100
  const longitude = Math.round(parseFloat(lng) * 100) / 100

  return {
    latitude,
    longitude
  }
}

export const setBackgroundClass = () => 'App wxTime' + new Date().getHours()

export const setUpLocationFallback = () => {
  const weatherContainer = document.querySelector('.block--weather')
  weatherContainer.setAttribute('data-mp-hidden', 'false')

  const locationFallbackContainer = document.querySelector('.block--location-fallback.weather')
  locationFallbackContainer.setAttribute('data-mp-hidden', 'true')

  const currentTime = new Date().getHours()
  const dayTime = currentTime >= 6 && currentTime <= 18 ? 'day' : 'night'
  locationFallbackContainer.classList.add(dayTime)
}
